import React, { useEffect, useMemo, useState } from "react";
import queryString from "query-string";
import { Formik, useFormikContext } from "formik";
import classNames from "classnames";
import * as yup from "yup";
import { Row, Col, Form, Button, Card, Image, Table, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { useSelector, useDispatch } from "react-redux";
import {
  selectPrice,
  CLASS,
  selectShouldShowRFQDetails,
  selectTier,
  TIERS,
  selectUserSettings,
  selectRateCodes,
  selectPortalSetting,
  selectUtilities,
  selectIsCustomPricing,
  COMMODITY,
  UNITS,
} from "../GetPrice";
import {
  selectSteps,
  selectSelectedSupplier,
  selectUSStates,
  selectEnrollmentFields,
  selectSupplierFields,
  selectCustomerInfo,
  selectSelectedDynamicFieldType,
  selectTaxExemptValue,
  selectFilledFieldsInInfo,
  selectAccountByAddress,
  selectUtilityAccountPattern,
  selectHasEmptyEnrollementAndSupplierFields,
  selectHasEmptyAdditionalInfoFields,
  selectCustomerLegalEntityName
} from "./priceAndCustomerDetails.selectors";
import Stepper from "./Stepper";
import SupplierCard from "./SupplierCard";
import { useHistory } from "react-router-dom";
import { actions } from "./priceAndCustomerDetails.slice";
import { actions as getPriceActions } from "../GetPrice/getPrice.slice";
import BusyIndicator, { REGIONS, getNamedBusyIndicator } from "../../widgets/busyIndicator";
import {
  getEnrollmentFields,
  getSupplierFields,
  getUSStates,
  searchForAccountByAddress,
  saveAllInformation
} from "./priceAndCustomerDetails.asyncActions";
import isEmpty from "lodash/isEmpty";
import LargeTierCard from "./LargeTierCard";
import { selectClientConfig } from "../clientContext";
import UploadDocuments from "./UploadDocuments"
import DocumentTable from "./DocumentTable"
import analytics from "../../helper/analytics"
import { getMonthIndex, selectFilters } from "../ShowPrices";
import { ContactMeButton } from "../ContactMeView/ContactMeButton";
import { showAddressLookup, showESIIDorECLID } from "./priceAndCustomerDeatils.helpers";
import { useRef } from "react"; 
import { ExitFlow } from "../ExitFlow/ExitFlow";
import Select, { components } from 'react-select';
import { ENEREX_STATES, HTMLREGEX, EXPECTEDFORMAT, unit } from "./priceAndCustomerDetails.constant";
import Images from "../../assets/images";
import { removeFromCustomerAccountsInfo, selectCustomerAccountsInfo } from ".";
import Overlay from "../../widgets/Tooltip";
import { getUsage } from "../../helper/getUsage";
import { getFormattedUsage } from "../utils/getFormattedUsage";
import handleCloseWidget from "../../helper/handleCloseWidget";



const Input = (props) => <components.Input {...props} isHidden={false} />;

const NoOptionsMessage = props => {
  return (
    <components.NoOptionsMessage {...props}>
      No records found?
      Remove the street type- Drive, Court, etc - and search again.
    </components.NoOptionsMessage>
  );
};

const DropdownIndicator = props => {
  return null;

};

const {
  saveCustomerInfo,
  setSteps,
  setCustomerLegalEntityName,
  setEnrollmentFields,
  setSupplierFields,
  setSelectedDynamicFieldType,
  setHasEmptyEnrollementAndSupplierFields,
  setHasEmptyAdditionalInfoFields,
  setTaxExemptValue,
  setFilledFieldsInInfo,
  resetSearchedAccount,
  addToCustomerAccountsInfo
} = actions;

const { savePrice } = getPriceActions
const [
  emptyString,
  BILLING,
  PHYSICAL,
  ADDRESS,
  STATE_NAME,
  CITY,
  ZIP_CODE,
  ENROLLMENT,
  NEW_CONTRACT,
  ADDITIONAL_INFORMATION,
] = [
    "",
    "Billing",
    "Physical",
    "addressLine1",
    "stateName",
    "city",
    "zip",
    "Enrollment",
    "New Contract",
    "Additional Information",
  ];

const { NAT_GAS, ELECTRIC } = unit;
const { TH, KWH } = UNITS;

const PriceDetails = () => {
  const dispatch = useDispatch();
  const steps = useSelector(selectSteps);
  const filters = useSelector(selectFilters);
  const priceDetails = useSelector(selectPrice);
  const utilities = useSelector(selectUtilities)
  const USStates = useSelector(selectUSStates);
  const enrollmentFields = useSelector(selectEnrollmentFields);
  const supplierFields = useSelector(selectSupplierFields);
  const customerInfo = useSelector(selectCustomerInfo);
  const tier = useSelector(selectTier);
  const shouldShowRFQDetails = useSelector(selectShouldShowRFQDetails);
  const history = useHistory();
  const userSettings = useSelector(selectUserSettings);
  const selectedSupplier = useSelector(selectSelectedSupplier);
  const clientConfig = useSelector(selectClientConfig);
  const portalSetting = useSelector(selectPortalSetting);
  const isCommercial = priceDetails.class === CLASS.COMMERCIAL
  const isCustomerLegalEntityNameAvailable = isCommercial || shouldShowRFQDetails;
  const rateCodes = useSelector(selectRateCodes);
  const [hasSamePhysicalAndBillingAddresses, setHasSamePhysicalAndBillingAddresses] = useState(false)
  const selectedDynamicFieldType = useSelector(selectSelectedDynamicFieldType)
  const taxExemptValue = useSelector(selectTaxExemptValue)
  const [hasErrorOnUpload, setHasErrorOnUpload] = useState(false)
  const [moveAhead, setMoveAhead] = useState(false);
  const [value, setValue] = useState(); //ACCOUNT INFO
  const [searchedAccount, setSearchedAccount] = useState({}); //ACCOUNT INFO
  const [menuIsOpen, setMenuIsOpen] = useState(false); //ACCOUNT INFO
  const [searchInputValue, setSearchInputValue] = useState("");//ACCOUNT INFO
  const [hasSameAsBillingAddresses, setHasSameAsBillingAddresses] = useState(false);//ACCOUNT INFO
  const [searchedESIID, setSearchedESIID] = useState(null); //ACCOUNT INFO
  const [billingAddress, setBillingAddress] = useState(null); //ACCOUNT INFO
  const [serviceAddress, setServiceAddress] = useState(null); // ACCOUNT INFO
  const [isTableEmpty, setIsTableEmpty] = useState(false); //ACCOUNT INFO
  const [show, setShow] = useState(false); //ACCOUNT INFO
  

  const { brokerageId, isFullScreen, authKey } = clientConfig;
  const { pipelineContacts, pipelineAddresses, customerName, supplierIdentifier } = userSettings;
  const { state, commodity, utility } = priceDetails;
  const isEnerexStatePresent = priceDetails.state && ENEREX_STATES.includes(priceDetails.state.name.toLowerCase());
  const portalSettings = useSelector(selectPortalSetting);
  const utilityAccountPattern = useSelector(selectUtilityAccountPattern); //ACCOUNT INFO
  const isStateTexas = priceDetails.state && showAddressLookup(priceDetails.state.id); // ACCOUNT INFO
  const isSearching = useSelector(getNamedBusyIndicator(REGIONS.SEARCH_ACCOUNT)); //ACCOUNT INFO
  const isCustomPricing = useSelector(selectIsCustomPricing); //ACCOUNT INFO
  const hasEmptyEnrollementAndSupplierFields = useSelector(selectHasEmptyEnrollementAndSupplierFields);
  const hasEmptyAdditionalInfoFields = useSelector(selectHasEmptyAdditionalInfoFields);
  const customerLegalEntityName = useSelector(selectCustomerLegalEntityName);
  const customerAccountInfo = useSelector(selectCustomerAccountsInfo);
  const fieldsData = useSelector(selectSupplierFields);

  const filledFieldsInInfo = useSelector(selectFilledFieldsInInfo);
  const fetchedAccountAddresses = useSelector(selectAccountByAddress);//ACCOUNT INFO
  //FILTERED ACCOUNT ADDRESSES
  const accountAddresses = showESIIDorECLID(priceDetails?.state?.id) ? fetchedAccountAddresses.filter(address => address.city.toLowerCase() === priceDetails.state.city.toLowerCase() && address.zipCode.substring(0, 5) === priceDetails.zipCode ) 
  : fetchedAccountAddresses.filter(address => address.city.toLowerCase() === priceDetails.state.city.toLowerCase() && address.zip.substring(0, 5) === priceDetails.zipCode);
  const formRef = useRef();
  const ref = useRef(); // ACCOUNT INFO

  const updatedRateCodes = rateCodes.map((each) => ({
    ...each,
    displayName: isEnerexStatePresent ? each.LoadProfile : each.RateClass,
  }));

  const { did: dealId, oid: opportunityId } = queryString.parse(window.location.search);

  const checkFieldsAreValid = (conditionalFields) => {
    const isConditionalVisibilityOnField = conditionalFields.every((each) => each.conditionalVisibilityOnField)
    if (isConditionalVisibilityOnField) {
      return conditionalFields.some((each) =>
        each?.conditionalVisibilityOnField?.some(
          (each) =>
            each.name === 'Class' && each.valueWhenShown === priceDetails.class
        )
      );
    } else return true;
  };

  const shouldSkipAdditionalInfo =
    supplierFields?.fieldsAsJson?.length === 0 ||
    !checkFieldsAreValid(supplierFields?.fieldsAsJson);

  const shouldSkipEnrollment =
    enrollmentFields.length === 0 || !checkFieldsAreValid(enrollmentFields);

    const options = showESIIDorECLID(priceDetails?.state?.id) ? accountAddresses.map((each, index) => ({
      label: `${each.address} ${each.city} ${each.zipCode.slice(0,5)}`,
      value: each.esiId,
      ind : index
    })) : accountAddresses.map((each, index) => ({
      label: each.fullAddress,
      value: each.accountNumber,
      ind : index
    }));

  // TODO :- ADD THESE FN INSIDE FORMIK ELSE REFACTOR
    // TODO :- REFACTOR THE FORM IN SUCH THAT EACH AND EVERY ADDRESS FIELD IS ISOLATED, DROP FORMIK IF REQUIRED

  const AutoSubmitToken = () => {
    // Grab values and submitForm from context
    const { values, submitForm, setFieldValue } = useFormikContext();
    const workToBeDone = () => {
      const { addressAccountsInfo, cityAccountsInfo, stateAccountsInfo, zipCodeAccountsInfo } = values;
      if (hasSameAsBillingAddresses) {
        const stateName = initialValues.state
        setFieldValue("address", addressAccountsInfo);
        setFieldValue("city", cityAccountsInfo);
        setFieldValue("state", stateAccountsInfo);
        setFieldValue("zipCode", zipCodeAccountsInfo);
      }
    }
    React.useEffect(() => {
      // Submit the form imperatively as an effect as soon as form values.token are 6 digits long            
      workToBeDone();
    }, [searchedAccount]);

    return null;
  };

  // FN WHICH AUTOMATICALLY FINDS THE ADDRESS AND CALLS FILL INFO
  const autoPopulate = (searchText) => {
    if(searchText) {
      const data = accountAddresses.find((address) => showESIIDorECLID(priceDetails?.state?.id) ? `${searchText} ${priceDetails.state.city} ${priceDetails.zipCode}`.toLowerCase() === `${address["address"]} ${address.city} ${address["zipCode"].substring(0, 5)}`.toLowerCase() :
       `${searchText} ${priceDetails.state.city} ${priceDetails.zipCode}`.toLowerCase() === `${address["serviceAddress1"] || address["serviceAddress2"]} ${address.city} ${address["zip"].substring(0, 5)}`.toLowerCase()
      );
      if(data){
        const address = showESIIDorECLID(priceDetails?.state?.id) ? data.address : (data.serviceAddress1 || data.serviceAddress2);
        setBillingAddress(address)
        setSearchedAccount(data);
        setSearchedESIID(data?.esiId || data?.accountNumber || "");
        setSearchInputValue(`${address} ${data.city} ${data[showESIIDorECLID(priceDetails?.state?.id) ? "zipCode" : "zip"].slice(0,5)}`);
        setValue(`${address} ${data.city} ${data[showESIIDorECLID(priceDetails?.state?.id) ? "zipCode" : "zip"].slice(0,5)}`);
        setHasSameAsBillingAddresses(!hasSameAsBillingAddresses);
        dispatch(setFilledFieldsInInfo({...filledFieldsInInfo , "billingAddress" : address, "billingCity" : data.city, "billingStateId" : priceDetails?.state?.id, "billingZipCode" : data[showESIIDorECLID(priceDetails?.state?.id) ? "zipCode" : "zip"].slice(0,5), "accountNumber" : data[showESIIDorECLID(priceDetails?.state?.id) ? "esiId" : "accountNumber"]}));
      }
    }
  }
  useMemo(() => autoPopulate(searchInputValue || ""), [(searchInputValue || "", accountAddresses)]); 


  useEffect(() => {
    if (!isEmpty(userSettings) && !utility) {
      const selectedUtility = utilities.find((each) => each.LDCIdentifier === selectedSupplier.LDCId)
      dispatch(savePrice({ ...priceDetails, utility: selectedUtility }))
    }
  }, [dispatch, priceDetails, utility, utilities, selectedSupplier, userSettings])

  useEffect(() => {
    isEmpty(USStates) && dispatch(getUSStates());
    const isAlreadyRFQ = steps.some((each) => each.label === NEW_CONTRACT);
    const isAlreadyHaveEnrollment = steps.some(
      (each) => each.label === ENROLLMENT
    );
    if (shouldShowRFQDetails && !isAlreadyRFQ) {
      const updatedSteps = steps.map((each) => {
        if (each.label === ENROLLMENT)
          return { label: NEW_CONTRACT, path: "contract" };
        else if (each.label === ADDITIONAL_INFORMATION) return { label: undefined };
        return each;
      });
      const newUpdatedSteps = updatedSteps.filter(
        (each) => each.label !== undefined
      );
      dispatch(setSteps(newUpdatedSteps));
    } else {
      if (selectedSupplier.PlanId && !isAlreadyHaveEnrollment) {
        const updatedSteps = steps.map((each) => {
          if (each.label === ADDITIONAL_INFORMATION)
            return { label: ENROLLMENT, path: "enrollment" };
          return each;
        });
        dispatch(setSteps(updatedSteps));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, shouldShowRFQDetails, selectedSupplier, USStates]);

  useEffect(() => {
    if (selectedDynamicFieldType) {
      const updatedSteps = steps.filter((each) => {
        if (
          selectedSupplier.PlanId &&
          each.label === ENROLLMENT &&
          shouldSkipEnrollment
        ) {
          dispatch(setHasEmptyEnrollementAndSupplierFields(true));
          return false;
        }
        if (
          !selectedSupplier.PlanId &&
          each.label === ADDITIONAL_INFORMATION &&
          shouldSkipAdditionalInfo
        ) {
          dispatch(setHasEmptyAdditionalInfoFields(true));
          return false;
        }
        return true;
      });
      dispatch(setSteps(updatedSteps));
      dispatch(setSelectedDynamicFieldType(emptyString));
    }
  }, [
    steps,
    selectedDynamicFieldType,
    selectedSupplier.PlanId,
    shouldSkipAdditionalInfo,
    shouldSkipEnrollment,
    supplierFields,
    priceDetails,
    dispatch,
  ]);

  useEffect(() => {
    if (!shouldShowRFQDetails && selectedSupplier) {
      if (selectedSupplier.PlanId && shouldSkipEnrollment) {

        dispatch(
          getEnrollmentFields({
            SupplierId: selectedSupplier.SupplierId,
            StateId: state.id,
            CommodityTypeId: commodity,
            BrokerId: brokerageId,
          })
        ).then(() => {
          dispatch(setSelectedDynamicFieldType(ENROLLMENT))
        });
      } else if (!selectedSupplier.PlanId) {
        shouldSkipAdditionalInfo &&
          dispatch(
            getSupplierFields({
              SupplierId: opportunityId
                ? supplierIdentifier
                : selectedSupplier.SupplierId,
              StateId: state?.id,
              CommodityTypeId: commodity,
              rateClass: selectedSupplier.RateClass,
              utilityId: selectedSupplier.LDCId,
              companyId: brokerageId,
              clientId: authKey
            })
          ).then(() => dispatch(setSelectedDynamicFieldType("AdditionalInfo")));
      }
    }
  }, [
    opportunityId,
    supplierIdentifier,
    selectedSupplier,
    state,
    dispatch,
    brokerageId,
    shouldShowRFQDetails,
    commodity,
    shouldSkipEnrollment,
    supplierFields?.fieldsAsJson?.length,
    shouldSkipAdditionalInfo
  ]);

  useEffect(() => {
    if(moveAhead){
      if (!hasEmptyEnrollementAndSupplierFields && !hasEmptyAdditionalInfoFields) {
        analytics.sendEventWithData("Account Information", { accounts: JSON.stringify(customerAccountInfo) }) 
        if (selectedSupplier.PlanId) {
          history.push("enrollment");
        } else {
          history.push("supplier-info");
        }
      }
      else submitData()
      
    }
  }, [moveAhead])


  const phoneRegExp = /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
  const isCommercialMatrix = isCommercial && !shouldShowRFQDetails
  yup.addMethod(yup.string, "verifyAccoutNumber", function(errorMessage){
    return this.test('test-accountNumber', errorMessage, function(value){
      const {path, createError} = this;
      if(value){
        if(customerAccountInfo.some((each) => each.accountNumber === value)){
          return createError({path, message: errorMessage[0]})
        }
        // else if(utilityAccountPattern && value.length !== utilityAccountPattern.replace(HTMLREGEX, '').length){
        //   return createError({path, message: <div style={{display: "inline"}} dangerouslySetInnerHTML={{__html: `${EXPECTEDFORMAT}${utilityAccountPattern}`}}></div>})
        // }
      }
      return true;
    });
  });
  yup.addMethod(yup.string, "checkBillingAddress", function(errorMessage){
    return this.test('test-billingAddress', errorMessage, function(value){
      if(hasSameAsBillingAddresses) value = billingAddress;

      const {path, createError} = this;
      if(value){
        return true
      }
      return createError({path, message: "Address is required"});
    });
  });
  
  //CREATED MULTIPLE YUP OBJECTS TO BY PASS THE REQUIRED VALIDATION IF THE DATA IS ALREADY PRESENT TABLE

  const accountNumberValidation = !(customerAccountInfo.length === 0) ? yup.string() : yup
  .string()
  .required(
    `${showESIIDorECLID(priceDetails?.state?.id) ? "ESIID" : "Account Number"}  is required`
  )
  .verifyAccoutNumber([`${showESIIDorECLID(priceDetails?.state?.id) ? "ESIID" : "Account Number"} already exists`, `Expected format ${utilityAccountPattern.replace(HTMLREGEX, '')}`])
  .matches(/^[a-zA-Z0-9]*$/, "Should not contain special characters");
  
  const addressValidation = !(customerAccountInfo.length === 0) ? yup.string() : yup.string()
  .checkBillingAddress(["Address is required"]);
  
  const addressAccountInfoValidation = !(customerAccountInfo.length === 0) ? yup.string() : yup.string().required("Service Address is required");

  const validation = yup.object().shape(
    {
      city: yup.string().test(
        "city",
        "City is required",
        (value) => shouldShowRFQDetails || hasSamePhysicalAndBillingAddresses || !!value).matches(/^[a-zA-Z ]*$/, "Please enter only alphabetical letters."),
      customerLegalEntityName: yup
        .string()
        .when("isCustomerLegalEntityNameAvailable", {
          is: true,
          then: yup.string().required("Customer Legal Entity Name is required"),
        }),
      email: yup
        .string()
        .email("Email must be a valid Email")
        .required("Email is required"),
      firstName: yup.string().required("First Name is required").matches(/^[a-zA-Z ]*$/, "Please enter only alphabetical letters."),
      lastName: yup.string().required("Last Name is required").matches(/^[a-zA-Z ]*$/, "Please enter only alphabetical letters."),
      personalPhone: yup
        .string()
        .matches(phoneRegExp, "Invalid Phone Number")
        .when("workPhone", {
          is: (workPhone) => !workPhone || workPhone.length === 0,
          then: yup.string().required("Personal or Work Phone is required"),
          otherwise: yup.string(),
        }),
      address: addressValidation,
      state: yup.string().test(
        "state",
        "State is required",
        (value) => shouldShowRFQDetails || hasSamePhysicalAndBillingAddresses || !!value),
      title: yup.string().matches(/^[a-zA-Z ]*$/, "Please enter only alphabetical letters."),
      workPhone: yup
        .string()
        .matches(phoneRegExp, "Invalid Phone Number")
        .when("personalPhone", {
          is: (personalPhone) => !personalPhone || personalPhone.length === 0,
          then: yup.string().required(),
          otherwise: yup.string(),
        }),
      zipCode: yup
        .string()
        .test(
          "zipCode",
          "Zip Code is required",
          (value) => shouldShowRFQDetails || hasSamePhysicalAndBillingAddresses || !!value)
        .test('len', 'Zip Code must contain at least 5 digits', val => (val && val.length >= 5) || shouldShowRFQDetails || hasSamePhysicalAndBillingAddresses),
      files: yup.array().test(
        "files",
        "files is required",
        (value) => !isCommercialMatrix || (value && value.length > 0)),
      physicalAddress: yup.string().test(
        "physicalAddress",
        "Address is required",
        (value) => !isCommercial || !!value),
      physicalState: yup.string().test(
        "physicalState",
        "State is required",
        (value) => !isCommercial || !!value),
      physicalZipCode: yup
        .string()
        .min(5, "Zip Code must contain at least 5 digits")
        .test(
          "physicalZipCode",
          "Zip Code is required",
          (value) => !isCommercial || !!value),
      physicalCity: yup.string().test(
        "physicalCity",
        "City is required",
        (value) => !isCommercial || !!value).matches(/^[a-zA-Z ]*$/, "Please enter only alphabetical letters."),
      taxExemptValue: yup.string().required("Tax Exempt is required"),
      accountNumber: accountNumberValidation,
    annualUsage: yup.string()
      .test(
        "annual usasge",
        "Annual Usage is required.",
        (value) => shouldShowRFQDetails ? !!value : true),
        cityAccountsInfo: yup.string().required("City is required"),
    meterNumber: yup.string().matches(/^[a-zA-Z0-9]*$/, "Should not contain special characters"),
    addressAccountsInfo: addressAccountInfoValidation,
    stateAccountsInfo: yup.string().required("State is required"),
    utility: yup.string().required("Utility is Required."),
    zipCodeAccountsInfo: yup
      .string()
      .min(5, "Zip Code must contain at least 5 digits")
      .required("Zip Code is required"),
    rateCode: yup.string(),
    },
    [["personalPhone", "workPhone"]]
  );
  const commercialValidation = yup.object().shape(
    {
      city: yup.string().test(
        "city",
        "City is required",
        (value) => shouldShowRFQDetails || hasSamePhysicalAndBillingAddresses || !!value).matches(/^[a-zA-Z ]*$/, "Please enter only alphabetical letters."),
      customerLegalEntityName: yup
        .string()
        .when("isCustomerLegalEntityNameAvailable", {
          is: true,
          then: yup.string().required("Customer Legal Entity Name is required"),
        }),
      email: yup
        .string()
        .email("Email must be a valid Email")
        .required("Email is required"),
      firstName: yup.string().required("First Name is required").matches(/^[a-zA-Z ]*$/, "Please enter only alphabetical letters."),
      lastName: yup.string().required("Last Name is required").matches(/^[a-zA-Z ]*$/, "Please enter only alphabetical letters."),
      personalPhone: yup
        .string()
        .matches(phoneRegExp, "Invalid Phone Number")
        .when("workPhone", {
          is: (workPhone) => !workPhone || workPhone.length === 0,
          then: yup.string().required("Personal or Work Phone is required"),
          otherwise: yup.string(),
        }),
      address: yup.string().test(
        "address",
        "Address is required",
        (value) => shouldShowRFQDetails || hasSamePhysicalAndBillingAddresses || !!value),
      state: yup.string().test(
        "state",
        "State is required",
        (value) => shouldShowRFQDetails || hasSamePhysicalAndBillingAddresses || !!value),
      title: yup.string().matches(/^[a-zA-Z ]*$/, "Please enter only alphabetical letters."),
      workPhone: yup
        .string()
        .matches(phoneRegExp, "Invalid Phone Number")
        .when("personalPhone", {
          is: (personalPhone) => !personalPhone || personalPhone.length === 0,
          then: yup.string().required(),
          otherwise: yup.string(),
        }),
      zipCode: yup
        .string()
        .test(
          "zipCode",
          "Zip Code is required",
          (value) => shouldShowRFQDetails || hasSamePhysicalAndBillingAddresses || !!value)
        .test('len', 'Zip Code must contain at least 5 digits', val => (val && val.length >= 5) || shouldShowRFQDetails || hasSamePhysicalAndBillingAddresses),
      files: yup.array(),
      physicalAddress: yup.string().test(
        "physicalAddress",
        "Address is required",
        (value) => !isCommercial || !!value),
      physicalState: yup.string().test(
        "physicalState",
        "State is required",
        (value) => !isCommercial || !!value),
      physicalZipCode: yup
        .string()
        .min(5, "Zip Code must contain at least 5 digits")
        .test(
          "physicalZipCode",
          "Zip Code is required",
          (value) => !isCommercial || !!value),
      physicalCity: yup.string().test(
        "physicalCity",
        "City is required",
        (value) => !isCommercial || !!value).matches(/^[a-zA-Z ]*$/, "Please enter only alphabetical letters."),
      taxExemptValue: yup.string().required("Tax Exempt is required"),
    },
    [["personalPhone", "workPhone"]]
  );

  const initialStateName = (intialStateId) => {
    const initialState = USStates.find(
      (states) => states.id === intialStateId
    );
    return initialState?.displayName;
  };

  const getAddress = (addressTypeName, fieldKey) => {
    const address = pipelineAddresses?.find((each) => each.addressTypeName === addressTypeName)
    return address && address[fieldKey]
  }

  const getStateName = (stateAbbreviation) => {
    const stateName = USStates.find(
      (states) => states.abbreviation === stateAbbreviation
    );
    return (
      stateName &&
      stateName.displayName
    );
  };

  const initialValues = {
    city: customerInfo?.billingAddress?.city || state?.city || getAddress(BILLING, CITY) || emptyString,
    customerLegalEntityName:
      customerInfo?.customerLegalEntityName || customerName || emptyString,
    email: customerInfo?.email || (pipelineContacts && pipelineContacts.length > 0 && pipelineContacts[0].emailWork) || emptyString,
    firstName:
      customerInfo?.firstName ||
      (pipelineContacts && pipelineContacts.length > 0 && pipelineContacts[0].firstName) ||
      emptyString,
    lastName:
      customerInfo?.lastName ||
      (pipelineContacts && pipelineContacts.length > 0 && pipelineContacts[0].lastName) ||
      emptyString,
    personalPhone: customerInfo?.personalPhone || (pipelineContacts && pipelineContacts.length > 0 && pipelineContacts[0].phonePersonal) || emptyString,
    address: billingAddress || getAddress(BILLING, ADDRESS) || emptyString,
    state:
      initialStateName(customerInfo?.billingAddress?.stateId) ||
      priceDetails?.state?.displayName ||
      getAddress(BILLING, STATE_NAME) ||
      emptyString,
    title: customerInfo?.title || (pipelineContacts && pipelineContacts.length > 0 && pipelineContacts[0].designation) || emptyString,
    workPhone: customerInfo?.workPhone || (pipelineContacts && pipelineContacts.length > 0 && pipelineContacts[0].phoneWork) || emptyString,
    zipCode:
      customerInfo?.billingAddress?.zipCode ||
      getAddress(BILLING, ZIP_CODE) ||
      priceDetails.zipCode ||
      emptyString,
    isCustomerLegalEntityNameAvailable: isCustomerLegalEntityNameAvailable,
    files: customerInfo?.files || [],
    physicalAddress: customerInfo?.address?.address || getAddress(PHYSICAL, ADDRESS) || emptyString,
    physicalCity: customerInfo?.address?.city || state?.city || getAddress(PHYSICAL, CITY) || emptyString,
    physicalState:
      state?.displayName ||
      initialStateName(customerInfo?.address?.stateId) ||
      getAddress(PHYSICAL, STATE_NAME) ||
      emptyString,
    physicalZipCode:
      filters.zipCode ||
      customerInfo?.address?.zipCode ||
      getAddress(PHYSICAL, ZIP_CODE) ||
      priceDetails.zipCode ||
      emptyString,
    taxExemptValue: taxExemptValue || emptyString,

    accountNumber: searchedAccount?.accountNumber || searchedAccount?.esiId || searchedESIID || "",
    annualUsage: searchedAccount?.annualUsage || "",
    cityAccountsInfo: searchedAccount?.city || priceDetails?.state?.city ||"",
    meterNumber: searchedAccount?.meterNumber || "",
    addressAccountsInfo: searchedAccount?.serviceAddress || searchedAccount?.serviceAddress1 || serviceAddress || searchedAccount?.address || "",
    stateAccountsInfo:
      getStateName(searchedAccount?.state) ||
      getStateName(priceDetails?.state?.abbreviation) ||
      "",
    utility: searchedAccount?.ldc ||
      selectedSupplier?.LDCName ||
      priceDetails?.utility?.LDCName ||
      "",
    zipCodeAccountsInfo: searchedAccount?.zipCode?.substring(0, 5) || searchedAccount?.zip?.substring(0, 5) || filters?.zipCode || priceDetails?.zipCode || "",
    rateCode: searchedAccount?.rateCode || priceDetails?.rateCode || "",
  };

  const onDropHandle = (uploadedFiles, acceptedFiles, setFieldValue) => {
    setHasErrorOnUpload(false)
    const uploads = [];
    acceptedFiles &&
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (r) => {
          uploads.push({
            base64Data: r.target.result,
            fileName: file.name,
            fileType: file.type,
            size: file.size,
          });
          if (uploads.length === acceptedFiles.length) {
            const files = [...uploadedFiles, ...uploads]
            setFieldValue("files", files)
            dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"files" : files}));
          }
        };
        reader.readAsDataURL(file);
      });
  };

  const removeFromUploadedFiles = (uploadedFiles, index, setFieldValue) => {
    const files = [...uploadedFiles]
    files.splice(index, 1);
    setFieldValue("files", files)
  };

  const onFieldChange = (setFieldValue, values) => {
    const updatedValue = !hasSamePhysicalAndBillingAddresses
    setHasSamePhysicalAndBillingAddresses(updatedValue)
    if (updatedValue) {
      const { physicalAddress, physicalCity, physicalState, physicalZipCode } = values
      setFieldValue("address", physicalAddress)
      setFieldValue("city", physicalCity)
      setFieldValue("state", physicalState)
      setFieldValue("zipCode", physicalZipCode)
    }
    else {
      setFieldValue("address", emptyString)
      setFieldValue("city", emptyString)
      setFieldValue("state", emptyString)
      setFieldValue("zipCode", emptyString)
    }
  }

  const loadSearchAccountOptions = (q) => {
    if (q !== "") {
      const data = showESIIDorECLID(priceDetails?.state?.id) ? {
        "ESIID": "",
        "SearchText": `${q} ${priceDetails?.state?.city} ${priceDetails.zipCode}`,
        "PageSize": 1000,
        "PageNumber": 1,
        "StateName": priceDetails?.state?.abbreviation,
        "LDCName": priceDetails?.utility?.LDCName || selectedSupplier.LDCName || "",
        "ZipCode": priceDetails?.zipCode,
        "SearchType": "Address",
        "OrderBy": "address",
        "CustomerClass": [],
        "Type" : "esiid"
      } : {
        "StateName": priceDetails?.state?.abbreviation,
        "SortColumnName": "",
        "Start": 0,
        "Length": 1000,
        "LDCIdentifiers": [priceDetails?.utility?.LDCName || selectedSupplier.LDCName || ""],
        "SearchText": `${q} ${priceDetails?.state?.city} ${priceDetails.zipCode}`,
        "Type": "ecl",
        "SearchBy" : "FullAddress"
      }
      dispatch(searchForAccountByAddress(data))
    }
  }

  const getStateIdByStateName = (stateName) => {
    const state = USStates.find(
      (each) => each.name.replaceAll("_", " ") === stateName?.toLowerCase()
    )
    return state?.id || ""
  };

  const checkIsBillingAddressValid = (customerInfo) => customerInfo && customerInfo.billingAddress &&Object.values(customerInfo.billingAddress).every(each => !!each);

  const findUtility = (utilityName) => utilities && utilities.find((each) => each.LDCName === utilityName);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Remove
    </Tooltip>
  );
  
  const submitData = () => {
    const {
      PlanId,
      SupplierId,
      SupplierName,
      Term,
      ProductType,
      Price,
      RateClass,
      PlanDescription,
      GreenPercentage,
      UDCCode,
      UDCID,
      Zone,
      UOM
    } = selectedSupplier;

    const isElectricCommodity = priceDetails.commodity === COMMODITY.ELECTRIC

    const quote = {
      planId: priceDetails.class === CLASS.RESIDENTIAL ? PlanId : null,
      supplierId: SupplierId,
      supplierName: SupplierName,
      Term: Term,
      product: ProductType,
      price: Price,
      notes: PlanDescription,
      rateClass: RateClass,
      Unit: isElectricCommodity
        ? ELECTRIC
        : UOM || NAT_GAS,
      GreenPercentage,
      UDCCode: priceDetails.class === CLASS.RESIDENTIAL ? UDCCode : undefined,
      UDCID: priceDetails.class === CLASS.RESIDENTIAL ? UDCID : undefined,
      LoadZoneName: Zone,
    };
    const meters = customerAccountInfo.map(({ utility, ...each }) => each);

    const usage = getUsage(portalSetting.keyValue, priceDetails);

    const documents = customerInfo?.files?.map(({ size, ...file }) => ({
      data: file,
    }));
    const contact = { ...customerInfo }
    delete contact.files
    analytics.sendEventWithData("Account Information", customerAccountInfo)
    const dataToSave = {
      opportunityId: opportunityId,
      dealId: dealId,
      customerLegalEntityName,
      taxExemptValue,
      class: priceDetails.class,
      commodityTypeId: priceDetails.commodity,
      annualUsageOrMonthlyBill: usage,
      zipCode: priceDetails.zipCode,
      promoCode: priceDetails.referralCode,
      quote,
      contact,
      meters,
      documents,
      startMonth: getMonthIndex(filters.month),
      startYear: filters.year,
      stateId: priceDetails.state.id,
      brokerageId,
    }
    if (fieldsData?.id)
      dataToSave.contractTemplate = {
        contractTemplateId: fieldsData?.id,
        contractSpecificFields: {},
      }
    dispatch(
      saveAllInformation({
        customerData: dataToSave,
      })
    ).then((res) => {
      if (res.payload)
        history.push("review")
      else
        setShow(true)
    });
  }
  
  const handleFormatUsage = (e) => e.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // FUNCTIONS WHICH FILLS INFO AFTER SELECTING THE ADDRESS FROM AUTO SEARCH DROPDOWN
  const fillinfo = (event) => {
    const data = accountAddresses.find(
      (each, index) =>
        each.esiId === event.value ||
        (each.accountNumber
          ? each.accountNumber === event.value
          : index === event.ind)
    );
    const address = showESIIDorECLID(priceDetails?.state?.id) ? data.address : (data.serviceAddress1 || data.serviceAddress2);
    setSearchedAccount(data);
    setSearchedESIID(data?.esiId || data?.accountNumber);
    setSearchInputValue(`${address} ${data.city} ${data[showESIIDorECLID(priceDetails?.state?.id) ? "zipCode" : "zip"].slice(0,5)}`);
    setValue(`${address} ${data.city} ${data[showESIIDorECLID(priceDetails?.state?.id) ? "zipCode" : "zip"].slice(0,5)}`);
    setHasSameAsBillingAddresses(true);
    setBillingAddress(address);
    setServiceAddress(data.address);
    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo , "billingAddress" : address, "billingCity" : data.city, "billingStateId" : priceDetails?.state?.id, "billingZipCode" : data[showESIIDorECLID(priceDetails?.state?.id) ? "zipCode" : "zip"].slice(0,5), "accountNumber" : data[showESIIDorECLID(priceDetails?.state?.id) ? "esiId" : "accountNumber"]}));
  }

  return (
    <div className={classNames("inner-widget", { "px-20": !isFullScreen })}>
      <Card className={classNames("p-4", { "min-h-100": isFullScreen })}>
        <div className="mb-4 py-2">
          <div className="d-flex align-items-center justify-content-between">
            {tier !== TIERS.LARGE && rateCodes.length > 0 ? (
              <Button
                variant="outline-primary"
                onClick={() => {
                  dispatch(setEnrollmentFields());
                  dispatch(setSupplierFields());
                  history.push(
                    shouldShowRFQDetails ? "select-pricing" : "show-prices"
                  );
                }}
              >
                {shouldShowRFQDetails ? "Back" : "Back To Prices"}
              </Button>
            ) : (
              <div />
            )}
            {shouldShowRFQDetails && <b>Custom Pricing Details</b>}
            <div className='d-flex align-items-center'>
              {portalSettings.phoneWork && <h6 className="sub-heading-text f-14 text-muted ">Need Assistance?: Call {portalSettings.phoneWork}</h6>}
              <ContactMeButton parent="PriceDetails" />
              <ExitFlow/>
            </div>
          </div>
        </div>
        <Row className="justify-content-center mb-3">
          <SupplierCard />
          {tier === TIERS.LARGE && <LargeTierCard />}
          <Col lg={8}>
            <BusyIndicator region={REGIONS.GET_CUSTOMER_INFO}>
              <Formik
                innerRef={formRef}
                enableReinitialize
                initialValues={initialValues}
                validationSchema={isCommercial ? commercialValidation : validation}
                onSubmit={(values, {resetForm}) => {
                  const {
                    firstName,
                    lastName,
                    title,
                    email,
                    personalPhone,
                    workPhone,
                    customerLegalEntityName,
                    address,
                    city,
                    state,
                    zipCode,
                    files,
                    physicalAddress,
                    physicalCity,
                    physicalState,
                    physicalZipCode,
                    taxExemptValue,
                    accountNumber,
                    meterNumber,
                    annualUsage,
                    addressAccountsInfo,
                    cityAccountsInfo,
                    zipCodeAccountsInfo,
                    rateCode,
                    stateAccountsInfo,
                    utility,
                  } = values;
                  const getState = (state) =>
                    USStates.find(
                      (each) =>
                        each.name.replaceAll("_", " ") === state.toLowerCase()
                    ) || {};
                  dispatch(setTaxExemptValue(taxExemptValue))
                  const customerInfoData = {
                    firstName,
                    lastName,
                    title,
                    email,
                    personalPhone,
                    workPhone,
                    billingAddress: {                      
                      address : address || billingAddress || customerInfo.billingAddress?.address || "",
                      city,
                      stateId: getState(state).id,
                      zipCode,
                    },
                    customerLegalEntityName,
                    files
                  };
                  if (isCommercial)
                    customerInfoData.address = {
                      address: physicalAddress,
                      city: physicalCity,
                      stateId: getState(physicalState).id,
                      zipCode: physicalZipCode
                    }

                  dispatch(setCustomerLegalEntityName(customerLegalEntityName));
                  dispatch(saveCustomerInfo(customerInfoData));
                  if(isCommercial) loadSearchAccountOptions(values.address);
                  if(isCommercial) history.push("accounts");
                  const dataForAnalytics = values
                  delete dataForAnalytics.files
                  analytics.sendEventWithData("Your Information", dataForAnalytics);

                  // ACCOUNT INFORMATION TO ADD
                  if(!isCommercial){  
                    const selectedStateId = getStateIdByStateName(stateAccountsInfo);
                    const utilitySelected = findUtility(utility);

                    let accountValues = {
                      utilityId: isCustomPricing ? utilitySelected?.LDCIdentifier : selectedSupplier.LDCId,
                      accountNumber,
                      serviceAddress: {
                        address: addressAccountsInfo,
                        city: cityAccountsInfo,
                        stateId: selectedStateId,
                        zipCode: zipCodeAccountsInfo,
                      },
                      utility,
                    };
                    if (meterNumber)
                      accountValues = { ...accountValues, meterNumber }
                    if (shouldShowRFQDetails)
                      accountValues = { ...accountValues, rateClassOrLoadProfile: rateCode, annualUsage }

                    dispatch(resetSearchedAccount());
                    if(accountNumber && customerAccountInfo && customerAccountInfo.length === 0)  dispatch(addToCustomerAccountsInfo(accountValues));
                    setIsTableEmpty(false);
                    resetForm({
                      ...initialValues,
                      accountNumber : "",
                      addressAccountsInfo : "",
                      cityAccountsInfo : "",
                      address : ""
                    });
                    setSearchedESIID("");
                    setBillingAddress("")
                    setSearchedAccount({});
                    setSearchInputValue("");
                    setHasSameAsBillingAddresses(false);
                    setMoveAhead(true);
                  }
                }}
              >
                {({ values, errors, touched, setFieldValue, handleBlur, handleSubmit, handleChange }) => {
                  // TODO : LOOK FOR ADDRESS, etc values
                  const handleSameAsBillingAddress = (values, ev) => {
                    const shouldBeFilled = !hasSameAsBillingAddresses;
                    setHasSameAsBillingAddresses(shouldBeFilled);
                    const { addressAccountsInfo, cityAccountsInfo, stateAccountsInfo, zipCodeAccountsInfo } = values;
                    if (shouldBeFilled) {
                      const stateName = initialValues.state
                      setFieldValue("address", addressAccountsInfo);
                      setFieldValue("city", cityAccountsInfo);
                      setFieldValue("state", stateAccountsInfo);
                      setFieldValue("zipCode", zipCodeAccountsInfo);
                      setBillingAddress(addressAccountsInfo);
                    }
                    else {
                      const zipCode = searchedAccount?.zipCode?.substring(0, 5) || priceDetails?.zipCode || "";
                      const state = getStateName(searchedAccount?.state) || getStateName(priceDetails?.state?.abbreviation) || "";
                      setFieldValue("address", "");
                      setFieldValue("city", cityAccountsInfo);
                      setFieldValue("state", stateAccountsInfo);
                      setFieldValue("zipCode", zipCodeAccountsInfo);
                      setBillingAddress("");
                    }
                    setTimeout(() => {
                      handleChange(ev)
                    })
                  };

                  // FN FOR POPULATING BILLING ADDRESS BASED ON SERVICE ADDRESS
                  const populateBillingAddress = (value) => {
                    if(hasSameAsBillingAddresses){ 
                      setFieldValue("address", value);
                      setBillingAddress(value);
                    }
                  }


                  const selectedUtility =
                    !isEmpty(values.utility) &&
                    utilities.find((e) => e.LDCName === values.utility);
                  const format = selectedUtility && selectedUtility.format;

                  
                  return(<>
                    <div className="wizard">
                      <Stepper pages={steps} currentPath="info" />
                      <div className="wizard-content" data-step="step1">
                        {isCustomerLegalEntityNameAvailable && (
                          <Form.Group as={Row} className="align-items-center mb-3">
                            <Col md={4}>
                              <Form.Label className="required">
                                Customer Legal Entity Name
                              </Form.Label>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type="text"
                                className={classNames("f-14", {
                                  error:
                                    errors.customerLegalEntityName &&
                                    touched.customerLegalEntityName,
                                })}
                                placeholder="Customer Legal Entity Name"
                                value={values.customerLegalEntityName}
                                onChange={(e) =>
                                  setFieldValue(
                                    "customerLegalEntityName",
                                    e.target.value
                                  )
                                }
                                onBlur={(e) =>{
                                  setFieldValue(
                                    "customerLegalEntityName",
                                    e.target.value.trim()
                                  )
                                  dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"customerLegalEntityName" : e.target.value.trim()})); 
                                }
                                }
                                maxLength={100}
                              />
                              {errors.customerLegalEntityName &&
                                touched.customerLegalEntityName && (
                                  <div className="error-message mt-1">
                                    {errors.customerLegalEntityName}
                                  </div>
                                )}
                            </Col>
                          </Form.Group>
                        )}
                        <Row className='mb-3'>
                          <Col md={6}>
                            <Form.Group as={Row} className="align-items-center">
                              <Col lg={4}>
                                <Form.Label className="required">First Name</Form.Label>
                              </Col>
                              <Col lg={8}>
                                <Form.Control
                                  type="text"
                                  className={classNames("f-14", {
                                    error:
                                      errors.firstName && touched.firstName,
                                  })}
                                  placeholder="John"
                                  value={values.firstName}
                                  onChange={(e) =>
                                    setFieldValue("firstName", e.target.value)
                                  }
                                  onBlur={(e) => {
                                    setFieldValue("firstName", e.target.value.trim());
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"firstName" : e.target.value.trim()}));
                                    // ADD FIRST NAME TO CUSTOMER INFO
                                    priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "firstName" : e.target.value.trim()}));
                                  }
                                  }
                                  maxLength={100}
                                />
                                {errors.firstName && touched.firstName && (
                                  <div className="error-message mt-1">
                                    {errors.firstName}
                                  </div>
                                )}
                              </Col>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group as={Row} className="align-items-center">
                              <Col lg={4}>
                                <Form.Label className="required">Last Name</Form.Label>
                              </Col>
                              <Col lg={8}>
                                <Form.Control
                                  type="text"
                                  className={classNames("f-14", {
                                    error: errors.lastName && touched.lastName,
                                  })}
                                  placeholder="Smith"
                                  value={values.lastName}
                                  onChange={(e) =>
                                    setFieldValue("lastName", e.target.value)
                                  }
                                  onBlur={(e) => {
                                    setFieldValue("lastName", e.target.value.trim())
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"lastName" : e.target.value.trim()})); 
                                    // LAST NAME WAS ADDED TO CUSTOMERINFO
                                    priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "lastName" : e.target.value.trim()}));
                                  }
                                  }
                                  maxLength={100}
                                />
                                {errors.lastName && touched.lastName && (
                                  <div className="error-message mt-1">
                                    {errors.lastName}
                                  </div>
                                )}
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                        {isCommercial && <Row className='mb-3'>
                          <Col md={6}>
                            <Form.Group as={Row} className="align-items-center">
                              <Col lg={4}>
                                <Form.Label>Title</Form.Label>
                              </Col>
                              <Col lg={8}>
                                <Form.Control
                                  type="text"
                                  className={classNames("f-14", {
                                    error: errors.title && touched.title,
                                  })}
                                  placeholder="Title"
                                  value={values.title}
                                  onChange={(e) =>
                                    setFieldValue("title", e.target.value)
                                  }
                                  onBlur={(e) =>{
                                    setFieldValue("title", e.target.value.trim())
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"title" : e.target.value.trim()}));   
                                  }
                                  }
                                  maxLength={100}
                                />
                                {errors.title && touched.title && (
                                  <div className="error-message mt-1">
                                    {errors.title}
                                  </div>
                                )}
                              </Col>
                            </Form.Group>
                          </Col>
                          <Col md={6} className="col-md-6">
                            <Form.Group as={Row} className="align-items-center">
                              <Col lg={4}>
                                <Form.Label>Work Phone</Form.Label>
                              </Col>
                              <Col lg={8}>
                                <NumberFormat
                                  format="(###) ###-####"
                                  mask="_"
                                  type="text"
                                  className={classNames("f-14 form-control", {
                                    error:
                                      errors.workPhone && touched.workPhone,
                                  })}
                                  placeholder="(111) 111-XXXX"
                                  value={values.workPhone}
                                  onChange={(e) =>{
                                    setFieldValue("workPhone", e.target.value);
                                  }
                                  }
                                  onBlur={(e) => {                                    
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"workPhone" : e.target.value.trim()})); 
                                  }}
                                />
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                        }
                        <Row className='mb-3'>
                          <Col md={6}>
                            <Form.Group as={Row} className="align-items-center">
                              <Col lg={4}>
                                <Form.Label className="required">Personal Phone</Form.Label>
                              </Col>
                              <Col lg={8}>
                                <NumberFormat
                                  format="(###) ###-####"
                                  mask="_"
                                  type="text"
                                  className={classNames("f-14 form-control", {
                                    error:
                                      errors.personalPhone &&
                                      touched.personalPhone,
                                  })}
                                  placeholder="(111) 111-XXXX"
                                  value={values.personalPhone}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "personalPhone",
                                      e.target.value
                                    );
                                  }}
                                  onBlur={(e) => {
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"personalPhone" : e.target.value.trim()})); 
                                    priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "personalPhone" : e.target.value.trim()}));
                                  }}
                                />
                                {errors.personalPhone &&
                                  touched.personalPhone && (
                                    <div className="error-message mt-1">
                                      {errors.personalPhone}
                                    </div>
                                  )}
                              </Col>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group as={Row} className="align-items-center">
                              <Col lg={4}>
                                <Form.Label className="required">Email</Form.Label>
                              </Col>
                              <Col lg={8}>
                                <Form.Control
                                  type="text"
                                  className={classNames("f-14", {
                                    error: errors.email && touched.email,
                                  })}
                                  placeholder="John@smith.com"
                                  value={values.email}
                                  onChange={(e) =>
                                    setFieldValue("email", e.target.value)
                                  }
                                  onBlur={(e) =>{
                                    setFieldValue("email", e.target.value.trim())
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"email" : e.target.value.trim()})); 
                                    //EMAIL ADDED FOR CUSTOMER INFOq
                                    priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "email" : e.target.value.trim()}));
                                  }}
                                  maxLength={100}
                                />
                                {errors.email && touched.email && (
                                  <div className="error-message mt-1">
                                    {errors.email}
                                  </div>
                                )}
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                        {isCommercial && <Form.Group>
                          <Form.Label className="required">Address</Form.Label>
                          <Row className="mx-n1 mb-3">
                            <Col lg={6} className="px-1 mt-3">
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  className={classNames("f-14", {
                                    error: errors.physicalAddress && touched.physicalAddress,
                                  })}
                                  placeholder="Address"
                                  value={values.physicalAddress}
                                  onChange={(e) => {
                                    setFieldValue("physicalAddress", e.target.value)
                                    if (hasSamePhysicalAndBillingAddresses)
                                      setFieldValue("address", e.target.value)
                                  }
                                  }
                                  onBlur={(e) => {
                                    setFieldValue("physicalAddress", e.target.value.trim())
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"physicalAddress" : e.target.value.trim()})); 
                                    if (hasSamePhysicalAndBillingAddresses) {
                                      setFieldValue("address", e.target.value.trim())
                                      dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"address" : e.target.value.trim()})); 
                                    }
                                  }
                                  }
                                />
                                {errors.physicalAddress && touched.physicalAddress && (
                                  <div className="error-message mt-1">
                                    {errors.physicalAddress}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col lg={2} md={4} className="px-1 mt-3">
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  className={classNames("f-14", {
                                    error: errors.physicalCity && touched.physicalCity,
                                  })}
                                  placeholder="City"
                                  value={values.physicalCity}
                                  onChange={(e) => {
                                    setFieldValue("physicalCity", e.target.value)
                                    if (hasSamePhysicalAndBillingAddresses)
                                      setFieldValue("city", e.target.value)
                                  }
                                  }
                                  onBlur={(e) => {
                                    setFieldValue("physicalCity", e.target.value.trim())
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"physicalCity" : e.target.value.trim()})); 
                                    if (hasSamePhysicalAndBillingAddresses){
                                      setFieldValue("city", e.target.value.trim())
                                      dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"city" : e.target.value.trim()})); 
                                    }
                                  }
                                  }
                                />
                                {errors.physicalCity && touched.physicalCity && (
                                  <div className="error-message mt-1">
                                    {errors.physicalCity}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col lg={2} md={4} className="px-1 mt-3">
                              <Form.Group>
                                <Form.Control
                                  as="select"
                                  className={classNames("f-14", {
                                    error: errors.physicalState && touched.physicalState,
                                  })}
                                  placeholder="State"
                                  value={values.physicalState}
                                  onChange={(e) => {
                                    setFieldValue("physicalState", e.target.value)
                                    if (hasSamePhysicalAndBillingAddresses)
                                      setFieldValue("state", e.target.value)
                                  }
                                  }
                                >
                                  <option value={emptyString}>Select state</option>

                                  {USStates.filter((states) =>
                                    states.country.includes("US")
                                  ).map((state) => {
                                    return (
                                      <option value={state.displayName} key={state.id}>
                                        {state.displayName}
                                      </option>
                                    );
                                  })}
                                </Form.Control>
                                {errors.physicalState && touched.physicalState && (
                                  <div className="error-message mt-1">
                                    {errors.physicalState}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col lg={2} md={4} className="px-1 mt-3">
                              <Form.Group>
                                <NumberFormat
                                  type="text"
                                  allowLeadingZeros={true}
                                  placeholder="Zip Code"
                                  className={classNames("f-14 form-control", {
                                    error: errors.physicalZipCode && touched.physicalZipCode,
                                  })}
                                  value={values.physicalZipCode}
                                  onChange={(e) => {
                                    setFieldValue("physicalZipCode", e.target.value)
                                    if (hasSamePhysicalAndBillingAddresses)
                                      setFieldValue("zipCode", e.target.value)
                                  }
                                  }
                                  allowNegative={false}
                                />
                                {errors.physicalZipCode && touched.physicalZipCode && (
                                  <div className="error-message mt-1">
                                    {errors.physicalZipCode}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>

                        </Form.Group>}
                        <Form.Group>
                          <Form.Label className={classNames({ required: !shouldShowRFQDetails })}>{isCommercial ? "Billing Address" : "Service Address"} </Form.Label>
                          {isCommercial && <Form.Check
                          style={{width:'auto',height:'auto',clip:'inherit'}}
                            className='custom-form ml-4 d-inline'
                            id="same-as-above-checkbox"
                            label="Same as above"
                            onChange={() => {
                              onFieldChange(setFieldValue, values);
                              const {address, city, stateId, zipCode} = values;
                              dispatch(setFilledFieldsInInfo({...filledFieldsInInfo , "billingAddress" : address, "billingCity" : city, "billingStateId" : stateId, "billingZipCode" : zipCode})); 
                            }}
                            checked={hasSamePhysicalAndBillingAddresses}
                          />}
                          {isCommercial ? <Row className="mx-n1 mb-3">
                            <Col lg={6} className="px-1 mt-3">
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  className={classNames("f-14", {
                                    error: errors.address && touched.address,
                                  })}
                                  placeholder="Address"
                                  value={values.address}
                                  onChange={(e) =>
                                    setFieldValue("address", e.target.value)
                                  }
                                  onBlur={(e) => {
                                    setFieldValue("address", e.target.value.trim())       
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"billingAddress" : e.target.value.trim()})); 
                                    //BILLING ADDRESS WAS ADDED
                                    let tempBillingAddress = customerInfo.billingAddress ? customerInfo.billingAddress : {} ;
                                    const {address, city, physicalState, zipCode} = values;
                                    // priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "billingAddress" : { 
                                    //   ...tempBillingAddress,
                                    //   "address" : e.target.value.trim(),
                                    //   "city" : city,
                                    //   "stateId" : USStates.find((each) =>each.name.replaceAll("_", " ") === physicalState.toLowerCase()).id,
                                    //   "zipCode" : zipCode
                                    // }}));
                                    setSearchInputValue(e.target.value.trim());
                                    const stateId = USStates.find((each) => each.name.replaceAll("_", " ") === physicalState.toLowerCase()).id || "";
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo , "billingAddress" : address, "billingCity" : city, "billingStateId" : stateId, "billingZipCode" : zipCode}));
                                    // TODO : LOAD ACCOUNT ADDRESSES
                                    loadSearchAccountOptions(e.target.value.trim());
                                  }}
                                  maxLength={100}
                                  disabled={hasSamePhysicalAndBillingAddresses}
                                />
                                {errors.address && touched.address && (
                                  <div className="error-message mt-1">
                                    {errors.address}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col lg={2} md={4} className="px-1 mt-3">
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  className={classNames("f-14", {
                                    error: errors.city && touched.city,
                                  })}
                                  placeholder="City"
                                  value={values.city}
                                  onChange={(e) =>
                                    setFieldValue("city", e.target.value)
                                  }
                                  onBlur={(e) => {
                                    setFieldValue("city", e.target.value.trim())
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"billingCity" : e.target.value.trim()}));  
                                    //BILLING ADDRESS WAS ADDED
                                    let tempBillingAddress = customerInfo.billingAddress ? customerInfo.billingAddress : {} ;
                                    // priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "billingAddress" : { ...tempBillingAddress,"city" : e.target.value.trim()}}));
                                  }}
                                  maxLength={100}
                                  disabled={hasSamePhysicalAndBillingAddresses}
                                />
                                {errors.city && touched.city && (
                                  <div className="error-message mt-1">
                                    {errors.city}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col lg={2} md={4} className="px-1 mt-3">
                              <Form.Group>
                                <Form.Control
                                  as="select"
                                  className={classNames("f-14", {
                                    error: errors.state && touched.state,
                                  })}
                                  placeholder="State"
                                  value={values.state}
                                  onChange={(e) =>{
                                    setFieldValue("state", e.target.value)
                                    //BILLING ADDRESS WAS ADDED
                                    let tempBillingAddress = customerInfo.billingAddress ? customerInfo.billingAddress : {} ;
                                    // priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "billingAddress" : { ...tempBillingAddress,"stateId" : USStates.find((each) =>each.name.replaceAll("_", " ") === e.target.value.toLowerCase()).id
                                    // }}))
                                    const stateId = USStates.find((each) => each.name.replaceAll("_", " ") === e.target.value.trim().toLowerCase()).id || "";
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"billingStateId" : stateId})); 
                                  }}
                                  disabled={hasSamePhysicalAndBillingAddresses}
                                >
                                  <option value={emptyString}>Select state</option>

                                  {USStates.filter((states) =>
                                    states.country.includes("US")
                                  ).map((state) => {
                                    return (
                                      <option value={state.displayName} key={state.id}>
                                        {state.displayName}
                                      </option>
                                    );
                                  })}
                                </Form.Control>
                                {errors.state && touched.state && (
                                  <div className="error-message mt-1">
                                    {errors.state}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col lg={2} md={4} className="px-1 mt-3">
                              <Form.Group>
                                <NumberFormat                                  
                                  type="text"
                                  allowLeadingZeros={true}
                                  placeholder="Zip Code"
                                  className={classNames("f-14 form-control", {
                                    error: errors.zipCode && touched.zipCode,
                                  })}
                                  value={values.zipCode}
                                  onChange={(e) =>
                                    setFieldValue("zipCode", e.target.value)
                                  }
                                  allowNegative={false}
                                  maxLength={100}
                                  disabled={hasSamePhysicalAndBillingAddresses} 
                                  onBlur={(e) => {
                                    dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"billingZipCode" : e.target.value.trim()}))
                                    //BILLING ADDRESS WAS ADDED
                                    let tempBillingAddress = customerInfo.billingAddress ? customerInfo.billingAddress : {} ;
                                    // priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "billingAddress" : { ...tempBillingAddress,"zipCode" : e.target.value.trim()}}))
                                  }}
                                />
                                {errors.zipCode && touched.zipCode && (
                                  <div className="error-message mt-1">
                                    {errors.zipCode}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                          </Row> : 
                          <Row className="mx-n1 mb-3">
                          <Col lg={6} className="px-1 mt-3">
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name="addressAccountsInfo"
                                placeholder="Service Address"
                                className={classNames({
                                  error: errors.addressAccountsInfo && touched.addressAccountsInfo,
                                })}
                                value={values.addressAccountsInfo}
                                onChange={(e) => {
                                  const {addressAccountsInfo, stateAccountsInfo, zipCodeAccountsInfo, cityAccountsInfo} = values;
                                  populateBillingAddress(e.target.value);
                                  handleChange(e);
                                  setServiceAddress(e.target.value);
                                  const stateId = USStates.find((each) => each.name.replaceAll("_", " ") === stateAccountsInfo.toLowerCase()).id || "";
                                  dispatch(setFilledFieldsInInfo({...filledFieldsInInfo , "serviceAddress" : e.target.value, "serviceAddressCity" : cityAccountsInfo, "serviceAddressStateId" : stateId, "serviceAddressZipCode" : zipCodeAccountsInfo})); 
                                }}
                                onBlur={(e) => {
                                  handleBlur(e);
                                  if(hasSameAsBillingAddresses) setBillingAddress(e.target.value.trim())
                                  setSearchInputValue(e.target.value.trim());
                                  // TODO : LOAD ACCOUNT ADDRESSES
                                  loadSearchAccountOptions(e.target.value.trim());
                                }}
                                maxLength={100}
                              />
                              {errors.addressAccountsInfo && touched.addressAccountsInfo && (
                                <div className="error-message mt-1">
                                  {errors.addressAccountsInfo}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col lg={2} md={4} className="px-1 mt-3">
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name="cityAccountsInfo"
                                className={classNames({
                                  error: errors.cityAccountsInfo && touched.cityAccountsInfo,
                                })}
                                placeholder="City"
                                value={values.cityAccountsInfo}
                                disabled={hasSameAsBillingAddresses}
                                onChange={(e) => {
                                  handleChange(e);
                                  dispatch(setFilledFieldsInInfo({...filledFieldsInInfo, "serviceAddressCity" : values.cityAccountsInfo})); 
                                }}
                                onBlur={handleBlur}
                                maxLength={100}
                              />
                              {errors.cityAccountsInfo && touched.cityAccountsInfo && (
                                <div className="error-message mt-1">
                                  {errors.cityAccountsInfo}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col lg={2} md={4} className="px-1 mt-3">
                            <Form.Group>
                              <Form.Control
                                as="select"
                                name="stateAccountsInfo"
                                className={classNames({
                                  error: errors.stateAccountsInfo && touched.stateAccountsInfo,
                                })}
                                placeholder="State"
                                disabled={
                                  searchedAccount?.state || priceDetails.state || hasSameAsBillingAddresses
                                }
                                value={initialValues.stateAccountsInfo}
                                onChange={(e) => {
                                  handleChange(e);
                                  const stateId = USStates.find((each) => each.name.replaceAll("_", " ") === values.stateAccountsInfo.toLowerCase()).id || "";
                                  dispatch(setFilledFieldsInInfo({...filledFieldsInInfo, "serviceAddressStateId" : stateId})); 
                                }}
                                onBlur={handleBlur}
                              >
                                <option value="">Select state</option>
                                {USStates.filter((states) =>
                                  states.country.includes("US")
                                ).map((state) => {
                                  const stateName = state.displayName
                                  return (
                                    <option value={stateName} key={state.id}>
                                      {stateName}
                                    </option>
                                  );
                                })}
                              </Form.Control>
                              {errors.state && touched.state && (
                                <div className="error-message mt-1">
                                  {errors.state}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col lg={2} md={4} className="px-1 mt-3">
                            <Form.Group>
                              <NumberFormat
                                type="text"
                                name="zipCodeAccountsInfo"
                                allowLeadingZeros={true}
                                placeholder="Zip Code"
                                className={classNames("f-14 form-control", {
                                  error: errors.zipCodeAccountsInfo && touched.zipCodeAccountsInfo,
                                })}
                                value={values.zipCodeAccountsInfo}
                                onChange={() => {
                                  setFieldValue(searchedAccount?.zipCode?.substring(0, 5) || searchedAccount?.zip?.substring(0, 5) || filters?.zipCode || priceDetails?.zipCode || "")
                                  dispatch(setFilledFieldsInInfo({...filledFieldsInInfo, "serviceAddressZipCode" : values.zipCodeAccountsInfo})); 
                                }}
                                onBlur={handleBlur}
                                allowNegative={false}
                                maxLength={100}
                              />
                              {errors.zipCodeAccountsInfo && touched.zipCodeAccountsInfo && (
                                <div className="error-message mt-1">
                                  {errors.zipCodeAccountsInfo}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                        </Row>}
                          {isCommercial &&
                            <Row className="mx-n1 align-items-center mb-3">
                              <Col lg={2} md={2} className="px-1">
                                <Form.Label className="required tax-extemp-mb">Tax Exempt </Form.Label>
                              </Col>
                              <Col lg={3} md={3} className="px-1">
                                <Form.Group>
                                  <Form.Control
                                    as="select"
                                    name="taxExemptValue"
                                    className={classNames("f-14", {
                                      error: errors.taxExemptValue && touched.taxExemptValue,
                                    })}
                                    placeholder="Select Tax Exempt"
                                    value={values.taxExemptValue}
                                    onChange={(e) =>{
                                        setFieldValue("taxExemptValue", e.target.value)
                                        dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"taxExemptValue" : e.target.value.trim()})); 
                                      }
                                    }
                                    onBlur={handleBlur}
                                  >
                                    <option value={"Yes"}>Yes</option>
                                    <option value={"No"}>No</option>
                                    <option value={"Partial"}>Partial</option>
                                  </Form.Control>
                                  {errors.taxExemptValue && touched.taxExemptValue && (
                                    <div className="error-message mt-1">
                                      {errors.taxExemptValue}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                            </Row>
                          }
                          {isCommercialMatrix && (
                            <>
                              {hasErrorOnUpload && <span className="error-message">File size limit exceeds 100 MB.</span>}
                              <UploadDocuments onDropHandle={(files, rej) => {
                                if (rej && rej.length > 0) setHasErrorOnUpload(true)
                                else
                                  onDropHandle(values.files, files, setFieldValue)
                              }} isRequired={false} hasError={(errors.files && touched.files) || hasErrorOnUpload} />
                              <DocumentTable uploadedFiles={values.files} removeFromUploadedFiles={(index) => removeFromUploadedFiles(values.files, index, setFieldValue)} />
                            </>
                          )}
                        </Form.Group>
                        {/* {priceDetails.class === CLASS.RESIDENTIAL ?<AutoSubmitToken/> : <></>} */}
                      </div>
                    </div>
                    {isCommercial ? <div className="wizard-footer d-flex">
                      <Button
                        variant="primary"
                        className="ml-auto"
                        onClick={handleSubmit}
                      >
                        Next
                      </Button>
                    </div> : <>
                    {/* ADD CHECK FOR COMMERCIAL */}
                    {/* ADD ACCOUNT INFORMATION COMPONENTS  */}
                    {isStateTexas && (
                      <Form.Group as={Row} className="mb-0 align-items-center">
                        <Col xs={12} sm={3} md={3} className="mb-15">
                          <Form.Label>Search by Address</Form.Label>
                        </Col>

                        <Col xs={12} sm={6} md={6} className="mb-15 d-flex">
                          <div className="flex-fill">
                            <Select
                              classNamePrefix="mySelect"
                              ref={ref}
                              onFocus={(e) => { 
                                setSearchInputValue(
                                  value ||
                                    searchedAccount?.address ||
                                    values.addressAccountsInfo
                                );
                                loadSearchAccountOptions(
                                  value ||
                                    searchedAccount?.address ||
                                    values.addressAccountsInfo
                                );
                                setMenuIsOpen(true);
                              }}
                              options={options}
                              placeholder={searchInputValue}
                              onChange={fillinfo}
                              show={isSearching}
                              inputValue={searchInputValue}
                              isLoading={isSearching}
                              value={value}
                              onInputChange={(e, { action }) => {
                                if (action === "input-change") {
                                  setSearchInputValue(e);
                                  setValue(e);
                                  loadSearchAccountOptions(e);
                                  setMenuIsOpen(true);
                                }
                                if (action === "menu-close") {
                                  setMenuIsOpen(false);
                                }
                              }}
                              menuIsOpen={menuIsOpen}
                              onBlur={() => {
                                setMenuIsOpen(false);
                              }}
                              components={{
                                Input,
                                DropdownIndicator,
                                NoOptionsMessage,
                              }}
                              filterOption={() => options}
                            />
                          </div>
                          <Button
                            className="ml-8 h-50"
                            onClick={() => {
                              if (ref && ref.current) {
                                ref.current.onInputFocus();
                                setMenuIsOpen(true);
                              }
                            }}
                          >
                            Search
                          </Button>
                        </Col>
                      </Form.Group>
                    )}
                    {/* ADD ACCOUNT INFORMATION COMPONENTS  */}
                    {/* Account Information to Add */}
                    <Form.Group>
                      <Form.Label className="required">Account Information to Add</Form.Label>
                      <Row className="mx-n1 mb-3">
                        <Col lg={6} className="px-1 mt-3">
                          <Form.Group>
                            {!isCustomPricing ? <Form.Control
                              as="select"
                              disabled={true}
                              value={values.utility}
                            >
                              <option value={values.utility}>
                                {values.utility}
                              </option>
                            </Form.Control> :
                              <Form.Control
                                as="select"
                                name="utility"
                                className={classNames({
                                  error: errors.utility && touched.utility,
                                })}
                                value={values.utility}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              >
                                <option key="0" value="">
                                  Select Utility
                                </option>
                                {utilities.map((utility) => (
                                  <option
                                    key={utility.LDCName}
                                    value={utility.LDCName}
                                  >
                                    {utility.LDCName}
                                  </option>
                                ))}
                              </Form.Control>}
                            {errors.utility && touched.utility && (
                              <div className="error-message mt-1">
                                {errors.utility}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col lg={isEnerexStatePresent ? 6 : 3} md={isEnerexStatePresent ? 12 : 6} className="px-1 mt-3">
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name="accountNumber"
                              className={classNames({
                                error:
                                  errors.accountNumber &&
                                  touched.accountNumber,
                                "form-input-tooltip": !values.accountNumber, //TODO Need to add this class when format doesn't matches
                              })}
                              placeholder={
                                showESIIDorECLID(priceDetails?.state?.id)
                                  ? "ESIID"
                                  : "Account Number"
                              }
                              value={values.accountNumber}
                              onChange={(e) => { 
                                setSearchedESIID(e.currentTarget.value); 
                                handleChange(e); 
                                dispatch(setFilledFieldsInInfo({...filledFieldsInInfo , "accountNumber": e.currentTarget.value}));  
                              }}
                              onBlur={handleBlur}
                              maxLength={100}
                            />
                              <div>
                                <div className="error-message mt-1" style={{display: "inline"}}>
                                  {errors.accountNumber && touched.accountNumber ? errors.accountNumber :(utilityAccountPattern ? <div style={{display: "inline"}} dangerouslySetInnerHTML={{__html: `${EXPECTEDFORMAT}${utilityAccountPattern}`}}></div> : <></>)}
                                </div>
                                {utilityAccountPattern && <Form.Text id="passwordHelpBlock" muted style={{display: "inline", float: "inline-end"}}>{`${searchedESIID ? searchedESIID.length : 0}/${utilityAccountPattern.replace(HTMLREGEX, '').length}`}</Form.Text>}
                              </div>
                          </Form.Group>
                        </Col>
                        {!isEnerexStatePresent && 
                        <Col lg={3} md={6} className="px-1 mt-3">
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name="meterNumber"
                              placeholder="Meter Number"
                              className={classNames("form-control", {
                                error:
                                  errors.meterNumber && touched.meterNumber,
                                "form-input-tooltip": !values.meterNumber, //TODO Need to add this class when format doesn't matches
                              })}
                              value={values.meterNumber}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              maxLength={100}
                            />
                            {!values.meterNumber &&
                              !isEmpty(format) && ( //TODO Need to add condition for format too.
                                <Overlay
                                  content={`Enter Meter Number Of This Format ${format}`}
                                >
                                  <Image
                                    src={Images.tooltipIcon}
                                    alt="tooltip-icon"
                                    className="tooltip-icon"
                                  />
                                </Overlay>
                              )}
                            {errors.meterNumber && touched.meterNumber && (
                              <div className="error-message mt-1">
                                {errors.meterNumber}
                              </div>
                            )}
                          </Form.Group>
                        </Col>}
                      </Row>
                      {<Form.Group>
                        <Form.Label>Billing Address</Form.Label>
                        <Form.Check
                        style={{width:'auto',height:'auto',clip:'inherit'}}
                          className='custom-form ml-4 d-inline'
                          id="same-as-billing-address"
                          label="Same as Service Address"
                          onChange={(ev) => handleSameAsBillingAddress(values, ev)}
                          checked={hasSameAsBillingAddresses}
                        />
                      </Form.Group>}
                      <Row className="mx-n1 mb-3">
                        <Col lg={6} className="px-1 mt-3">
                          <Form.Group>
                          <Form.Control
                              type="text"
                              className={classNames("f-14", {
                                error: errors.address && touched.address,
                              })}
                              placeholder="Address"
                              value={values.address || billingAddress}
                              onChange={(e) =>{
                                const {address, city, physicalState, zipCode} = values;
                                setFieldValue("address", e.target.value)
                                setBillingAddress(e.target.value)
                                const stateId = USStates.find((each) => each.name.replaceAll("_", " ") === state.displayName.toLowerCase()).id || "";
                                dispatch(setFilledFieldsInInfo({...filledFieldsInInfo , "billingAddress" : address, "billingCity" : city, "billingStateId" : stateId, "billingZipCode" : zipCode}));
                              }}
                              onBlur={(e) => {
                                setFieldValue("address", e.target.value.trim())         
                                //BILLING ADDRESS WAS ADDED
                                const {address, city, zipCode} = values;
                                // priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "billingAddress" : { 
                                //   ...tempBillingAddress,
                                //   "address" : e.target.value.trim(),
                                //   "city" : city,
                                //   "stateId" : USStates.find((each) =>each.name.replaceAll("_", " ") === physicalState.toLowerCase()).id,
                                //   "zipCode" : zipCode
                                // }}));
                                // dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"billingAddress" : e.target.value.trim()})); 
                                const stateId = USStates.find((each) => each.name.replaceAll("_", " ") === state.displayName.toLowerCase()).id || "";
                                dispatch(setFilledFieldsInInfo({...filledFieldsInInfo , "billingAddress" : address, "billingCity" : city, "billingStateId" : stateId, "billingZipCode" : zipCode})); 
                              }}
                              maxLength={100}
                              disabled={hasSameAsBillingAddresses}
                            />
                            {errors.address && touched.address && (
                              <div className="error-message mt-1">
                                {errors.address}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col lg={2} md={4} className="px-1 mt-3">
                          <Form.Group>
                            <Form.Control
                              type="text"
                              className={classNames("f-14", {
                                error: errors.city && touched.city,
                              })}
                              placeholder="City"
                              value={values.city}
                              onChange={(e) =>
                                setFieldValue("city", e.target.value)
                              }
                              onBlur={(e) => {
                                setFieldValue("city", e.target.value.trim())
                                //BILLING ADDRESS WAS ADDED
                                let tempBillingAddress = customerInfo.billingAddress ? customerInfo.billingAddress : {} ;
                                priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "billingAddress" : { ...tempBillingAddress,"city" : e.target.value.trim()}}));
                                dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"billingCity" : e.target.value.trim()})); 
                              }}
                              maxLength={100}
                              disabled={hasSameAsBillingAddresses}
                            />
                            {errors.city && touched.city && (
                              <div className="error-message mt-1">
                                {errors.city}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col lg={2} md={4} className="px-1 mt-3">
                          <Form.Group>
                            <Form.Control
                              as="select"
                              className={classNames("f-14", {
                                error: errors.state && touched.state,
                              })}
                              placeholder="State"
                              value={values.state}
                              onChange={(e) =>{
                                setFieldValue("state", e.target.value)
                                //BILLING ADDRESS WAS ADDED
                                let tempBillingAddress = customerInfo.billingAddress ? customerInfo.billingAddress : {} ;
                                priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "billingAddress" : { ...tempBillingAddress,"stateId" : USStates.find((each) =>each.name.replaceAll("_", " ") === e.target.value.toLowerCase()).id
                                }}))
                                const stateId = USStates.find((each) => each.name.replaceAll("_", " ") === e.target.value.trim().toLowerCase()).id || "";
                                dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"billingStateId" : stateId})); 
                              }}
                              disabled={hasSameAsBillingAddresses}
                            >
                              <option value={emptyString}>Select state</option>

                              {USStates.filter((states) =>
                                states.country.includes("US")
                              ).map((state) => {
                                return (
                                  <option value={state.displayName} key={state.id}>
                                    {state.displayName}
                                  </option>
                                );
                              })}
                            </Form.Control>
                            {errors.state && touched.state && (
                              <div className="error-message mt-1">
                                {errors.state}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col lg={2} md={4} className="px-1 mt-3">
                          <Form.Group>
                            <NumberFormat                                  
                              type="text"
                              allowLeadingZeros={true}
                              placeholder="Zip Code"
                              className={classNames("f-14 form-control", {
                                error: errors.zipCode && touched.zipCode,
                              })}
                              value={values.zipCode}
                              onChange={(e) =>
                                setFieldValue("zipCode", e.target.value)
                              }
                              allowNegative={false}
                              maxLength={100}
                              disabled={hasSameAsBillingAddresses} 
                              onBlur={(e) => {
                                dispatch(setFilledFieldsInInfo({...filledFieldsInInfo ,"billingZipCode" : e.target.value.trim()}));
                                
                                //BILLING ADDRESS WAS ADDED
                                let tempBillingAddress = customerInfo.billingAddress ? customerInfo.billingAddress : {} ;
                                priceDetails.class === CLASS.RESIDENTIAL && dispatch(saveCustomerInfo({...customerInfo, "billingAddress" : { ...tempBillingAddress,"zipCode" : e.target.value.trim()}}))
                              }}
                            />
                            {errors.zipCode && touched.zipCode && (
                              <div className="error-message mt-1">
                                {errors.zipCode}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mx-n1 mb-3">
                        <Col lg={5} className="px-1">
                          {shouldShowRFQDetails && <Form.Group className="input-group">
                            <NumberFormat
                              type="text"
                              name="annualUsage"
                              className={classNames("form-control", {
                                error:
                                  errors.annualUsage && touched.annualUsage,
                              })}
                              placeholder="Annual Usage"
                              value={values.annualUsage}
                              onChange={(e) =>
                                setFieldValue("annualUsage", getFormattedUsage(e.target.value))
                              }
                              onBlur={handleBlur}
                              allowNegative={false}
                              thousandSeparator={true}
                              maxLength={16}
                            />
                            <InputGroup.Text className="input-group-text-right">{priceDetails.commodity === COMMODITY.NAT_GAS ? TH : KWH}</InputGroup.Text>
                            {errors.annualUsage && touched.annualUsage && (
                              <div className="error-message mt-1">
                                {errors.annualUsage}
                              </div>
                            )}
                          </Form.Group>}
                        </Col>
                        <Col lg={5} md={6} className="px-1">
                          {shouldShowRFQDetails && <Form.Group>
                            <Form.Control
                              as="select"
                              name="rateCode"
                              className={classNames({
                                error: errors.rateCode && touched.rateCode,
                              })}
                              value={values.rateCode}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            >
                              <option key="0" value="">
                                {isEnerexStatePresent
                                  ? "Select Load Profile"
                                  : "Select Rate Code"}
                              </option>
                              {updatedRateCodes.map((rateCode) => (
                                <option
                                  key={rateCode.RateClass}
                                  value={isEnerexStatePresent ?
                                    rateCode.LoadProfile :
                                    rateCode.RateClass}
                                >
                                  {rateCode.RateClass}
                                </option>
                              ))}
                            </Form.Control>
                            {errors.rateCode && touched.rateCode && (
                              <div className="error-message mt-1">
                                {errors.rateCode}
                              </div>
                            )}
                          </Form.Group>}
                        </Col>
                      </Row>
                      {/* TABLE DATA */}
                      {isCommercial ? <></> : 
                      <>
                      <BusyIndicator region={REGIONS.GET_CUSTOMER_ACCOUNT_INFO}>
                        <div className="table-responsive">
                          <Table className="table table-bordered table-striped pd-half">
                            <thead>
                              <tr>
                                <th>Utility</th>
                                <th>
                                {showESIIDorECLID(priceDetails?.state?.id) ? "ESIID" : "Account Number"}
                                </th>
                                {!isEnerexStatePresent && <th>Meter Number</th>}
                                {shouldShowRFQDetails && <th>Annual Usage</th>}
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {customerAccountInfo.length === 0 ? (
                                <tr>
                                  <td colSpan="5" className="text-center">
                                    No accounts have been added yet
                                  </td>
                                </tr>
                              ) : (
                                customerAccountInfo.map(
                                  (
                                    {
                                      utility,
                                      accountNumber,
                                      meterNumber,
                                      annualUsage,
                                    },
                                    index
                                  ) => {
                                    return (
                                      <tr key={index}>
                                        <td>{utility}</td>
                                        <td>{accountNumber}</td>
                                        {!isEnerexStatePresent && <td>{meterNumber}</td>}
                                        {shouldShowRFQDetails && <td>{handleFormatUsage(annualUsage)}</td>}
                                        <td className="text-center">
                                          <Button
                                            variant="link"
                                            className="p-0 text-danger"
                                            onClick={() =>
                                              dispatch(
                                                removeFromCustomerAccountsInfo(
                                                  accountNumber
                                                )
                                              )
                                            }
                                          >
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={renderTooltip}
                                            >
                                              <i className="fa fa-trash trash-alt fa-2x"></i>
                                            </OverlayTrigger>
                                          </Button>
                                        </td>
                                      </tr>
                                    );
                                  }
                                )
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </BusyIndicator>
                      {isTableEmpty && (
                        <div className="error-message mt-1">
                          Please add Account Information
                        </div>
                      )}
                      {customerAccountInfo.length > 0 ? <div className="error-message mt-1"> {` ${showESIIDorECLID(priceDetails?.state?.id) ? "ESIID" : "Account Number"} has already been added`} </div> : <></>}
                      {/* TABLE DATA */}
                          
                      <Row>
                        <Col lg={11}></Col>
                        <Col lg={1} md={6} clasName="px-1">
                          <Form.Group>
                          <Overlay content={`Add ${showESIIDorECLID(priceDetails?.state?.id) ? "ESIID" : "Account Number"} and continue`}>
                            <Button
                              variant="primary"
                              className="ml-auto"
                              onClick={() => {
                               handleSubmit();
                              }}
                            >
                              Add
                            </Button>
                          </Overlay>
                          </Form.Group>
                        </Col>
                      </Row>
                      {/* TABLE DATA */}
                      </>}
                    </Form.Group>
                    {/* Account Information to Add */}
                    </>}
                  </>)
                }}
              </Formik>
              
            </BusyIndicator>
          </Col>
        </Row>
      </Card>
    </div>
  );
};
export default PriceDetails;
